import * as Stimulus from "@hotwired/stimulus"

/**
 * Triggers a preview. Intended for user with form changes.
 *
 * Will ignore changes from the agreeInput and prevent
 * triggering a preview.
 **/
export class FormFinePrintController extends Stimulus.Controller {
    static get targets() {
        return ["previewButton", "agreeInput"];
    }

    initialize() {
        if (!this.hasPreviewButtonTarget) {
            console.warn("No preview button target found");
        }
        if (!this.hasAgreeInputTarget) {
            console.warn("No agree input target found");
        }
        this.form = this.element.querySelector("form");
        if (!this.form) {
            console.warn("No contained form found");
        }
    }

    connect() {
        this.preview({ target: false })
    }

    previewDebounceTimer = null;

    previewDebounce(e) {
        clearTimeout(this.previewDebounceTimer);
        this.previewDebounceTimer = setTimeout(() => {
            this.preview(e)
            this.previewDebounceTimer = null;
        }, 300);
    }

    preview(e) {
        if (e.target == this.agreeInputTarget) {
            return;
        }
        this.agreeInputTarget.checked = true;
        if (this.form && this.form.checkValidity()) {
            this.previewButtonTarget.click();
        }
        this.agreeInputTarget.checked = false;
    }
}
